export default [
  {
    path: '/',
    name: 'homepage',
    component: () => import('../../views/Index.vue'),
    beforeEnter: (to, from, next) => {
      const currentUser = JSON.parse(localStorage.getItem('user'))
      if (!currentUser) {
        return next()
      } else {
        switch (currentUser.roleId) {
          case 1:
          case 2:
          case 3: return next({ name: 'admin.dashboard' })
          case 4: return next({ name: 'admin.delivery' })
          case 5: return next({ name: 'admin.personalCollection' })
          case 6: return next({ name: 'user.dashboard' })
          case 7: return next({ name: 'boarder.main' })
        }
      }
    }
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../../components/forms/admin/LoginForm'),
    meta: {
      auth: false
    }
  },
  {
    path: '/403',
    name: '403',
    component: () => import('../../views/Unauthorized')
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('../../components/forms/admin/RegisterForm'),
    meta: {
      auth: false
    }
  },
  {
    path: '/quick-register',
    name: 'quick-register',
    component: () => import('../../components/forms/admin/QuickRegisterForm'),
    meta: {
      auth: false
    }
  },
  {
    path: '/verification-success',
    component: () => import('../../views/VerificationSuccess'),
    meta: {
      auth: false
    }
  },
  {
    path: '/reset-password',
    name: 'sendResetPasswordMail',
    component: () => import('../../views/SendResetPasswordMail'),
    meta: {
      auth: false
    }
  },
  {
    path: '/password-reset',
    name: 'resetPassword',
    component: () => import('../../views/ResetPassword'),
    meta: {
      auth: false
    }
  },
  {
    path: '/invalid-signature',
    component: () => import('../../views/InvalidSignature')
  },
  {
    path: '/resend-email',
    component: () => import('../../views/ResendActivationEmail'),
    name: 'resendEmail'
  },
  {
    path: '*',
    component: () => import('../../views/NotFound')
  }
]
